import { render, staticRenderFns } from "./HoverBlocks.vue?vue&type=template&id=6d4b80b8&"
import script from "./HoverBlocks.vue?vue&type=script&lang=js&"
export * from "./HoverBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports